import { NgIf, NgFor } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterLink, RouterOutlet, NavigationEnd } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseHorizontalNavigationComponent, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';
import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { NetworkPanelComponent } from 'app/modules/network_panel/network_panel.component';
import { AuthService } from 'app/core/auth/auth.service';
// import { AuthService } from 'app/core/auth/auth.service';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { FooterComponent } from 'app/modules/landing/footer/footer.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { sha256 } from 'js-sha256';
import { CoverageVisibilityService } from 'app/modules/landing/home/coverage-visibility.service';
import { UserIdleService } from 'angular-user-idle';
import { SpeedTestComponent } from 'app/modules/dashboard/speed-test/speed-test.component';



@Component({
    selector     : 'enterprise-layout',
    templateUrl  : './enterprise.component.html',
    styleUrls    : ['./enterprise.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [
        MatMenuModule, MatBadgeModule, FooterComponent, SharedMethodsModule, FuseLoadingBarComponent, NgIf, NgFor, RouterLink,
        FuseVerticalNavigationComponent, MatButtonModule, MatIconModule, FuseFullscreenComponent, ShortcutsComponent,
        FuseHorizontalNavigationComponent, RouterOutlet, QuickChatComponent, NetworkPanelComponent, MatDialogModule, SpeedTestComponent
    ],
})
export class EnterpriseLayoutComponent implements OnInit, OnDestroy
{
    @ViewChild('searchTextRef') searchInputRef: ElementRef;
    @ViewChild('inActivityDialog') inActivityDialog: any;
    @ViewChild('mainNavigation', { static: false }) mainNav: any;
    
    isScreenSmall: boolean;
    navigation: Navigation;
    loggedIn: boolean;
    customerAccount:any;
    shortenedProfileDisplay:string;
    public cartValue: number;
    showCoverageButton = false;
    public countDownValue: number;
    private inactivityCount = new BehaviorSubject<number>(0);
    public isAuthPage = false;

    // Notification properties
    public notifications: any[] = [];
    public latestPendingDO: any;
    public accountInArrears: boolean = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _authService: AuthService,
        private _sharedMethods: SharedMethodsModule,
        private router: Router,
        private _webStorage: WebStorage,
        private dialog: MatDialog,
        private coverageVisibilityService: CoverageVisibilityService,
        private userIdle: UserIdleService,
    )
    {
        // Listen for route changes to update isAuthPage
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.isAuthPage = ['/sign-up', '/sign-in'].includes(this.router.url.split('?')[0]);
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit()
    {

        // if (this._authService._authenticated) {
        //     console.log(this._authService._authenticated);
        //     this.hashCustomerDetails();
        // }

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) =>
            {
                this.navigation = navigation;
            });
            
        // Subscribe to authentication status changes
        this._authService.authenticationStatus$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((isAuthenticated: boolean) =>
            {
                if (isAuthenticated && !this.loggedIn) {
                    // User just signed in, load account details
                    this.loadCustomerAccount();
                } else if (!isAuthenticated && this.loggedIn) {
                    // User just signed out
                    this.loggedIn = false;
                    this.customerAccount = null;
                    this.shortenedProfileDisplay = null;
                }
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
            {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

           
        var accessToken = this._authService.accessToken;
     

        if (accessToken)
        {            
            this.loadCustomerAccount();
        }
        
        // Set initial authentication status for the observable
        if (accessToken && this._authService._authenticated) {
            // Trigger the observable to initialize with current state
            // The subscription above will handle the UI updates
        }

        // Register to Cart Subject
        this._webStorage.CartInfo.subscribe({
            next: (res) => {
                if (res.PackageEntityID) {
                    this.cartValue = 1
                } else {
                    this.cartValue = 0
                }
            }
        })

        // Force the coverage button to be active on initial load of app, as only home screen needs to set the hidden state (do not change the default)
        this.coverageVisibilityService.isInputOutOfView$.next(true); 
        this.coverageVisibilityService.isInputOutOfView$.subscribe(isOutOfView => {
            this.showCoverageButton = isOutOfView;
            
            if (this.navigation && this.navigation.horizontalLoggedIn) {
                const nav = this.navigation.horizontalLoggedIn;
                const checkCoverageItem = nav.find(i => i.id === 'checkCoverage');
                if (checkCoverageItem) {
                    checkCoverageItem.hidden = () => !isOutOfView;
                    checkCoverageItem.function = () => {
                        if (this.router.url.split('?')[0] === '/home' || this.router.url === '/') {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        } else {
                            this.coverageVisibilityService.show();
                        }
                    };
                }
                this.navigation.horizontalLoggedIn = [...nav];
                const navComponent = this._fuseNavigationService.getComponent('mainNavigation') as any;
                if (navComponent && typeof navComponent.refresh === 'function') navComponent.refresh();
            }
        });
    }

    private async loadCustomerAccount(): Promise<void> 
    {
        const res = await this._sharedMethods.getCustomerAccount();
        
        if (res.success && res.result) 
        {
            this.customerAccount = res.result;
            this.loggedIn = true;
            this.shortenedProfileDisplay = this.getFirstLetters(this.customerAccount.AccountName);

            // Check for account arrears and create notification
            if (this.customerAccount.TotalArrears > 0) {
                this.accountInArrears = true;
                this.createNotification('Account in Arrears', 'Account_in_Arrears', null);
            }

            // Get pending debit order and create notification
            await this.getPendingDebitOrder();

            // console.log(this.notifications);

            //Start watching for user inactivity.
                        this.userIdle.startWatching();
                        
                        // Start watching when user idle is starting.
                        this.userIdle.onTimerStart().subscribe(count => {
                            this.inactivityCount.next(count);
                        });


                        // Subscribe to countdown ticks
                        this.inactivityCount.subscribe(value => {
                            this.countDownValue = 60 - value;
                            if (value == 1) {
                                this.dialog.open(this.inActivityDialog, {
                                    width: '500px',
                                    backdropClass: 'blurModalBackground'
                                });
                            }
                        });
                        
                        // Start watch when time is up.
                        this.userIdle.onTimeout().subscribe(() => {
                            
                            this.dialog.closeAll();
                            this.userIdle.stopTimer();
                            this.userIdle.stopWatching();
                            this.loggedIn = false;

                            this._authService.signOut();
                            this.router.navigate(['/home']);
                        });
        } 
        else 
        {
            this.loggedIn = false;
        }
    }

    public resetInactivityTimer() {
        this.dialog.closeAll();
        this.userIdle.stopTimer();
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    onCheckCoverageClick(): void {
        const path = this.router.url.split('?')[0].replace(/\/+$/, '').toLowerCase();

        // Close the side nav if open
        if (this.mainNav && typeof this.mainNav.close === 'function') {
            this.mainNav.close();
        }

        // Perform routing or modal logic
        if (path === '/home' || path === '') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            this.coverageVisibilityService.show();
        }
    }

    onSidenavOpenedChange(opened: boolean): void {
        this.coverageVisibilityService.isInputOutOfView$.next(true);
        const path = this.router.url.split('?')[0].replace(/\/+$/, '').toLowerCase();
        if (path === '/home' || path === '') {
            this.coverageVisibilityService.isInputOutOfView$.next(false);
        }
    }


    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    getFirstLetters(profileName)
    {
        return profileName
          .split(' ')
          .map(word => word[0])
          .join('');
    }

    menuItemClick(...navItems) 
    {
        if (navItems.filter(Boolean).length > 2) {
            const queryParam = navItems.filter(Boolean);
            const navObj = queryParam.splice(0,2)
            this.router.navigate(navObj, {queryParams: { segment: queryParam}});
        } else {
            const navObj = navItems.filter(Boolean);
            this.router.navigate(navObj);
        }
    }

    // signOutPrompt(templateRef: any) {
    //     this.dialog.open(templateRef, {
    //         width: '800px',
    //         backdropClass: 'blurModalBackground'
    //       });
    // }

    // closeDialog(): void {
    //     this.dialog.closeAll();
    // }

    signOut(): void
    {
        sessionStorage.removeItem('emailHash');
        sessionStorage.removeItem('phoneHash');

        this._router.navigate(['/sign-out']);
        // this.dialog.closeAll();
    }

    signIn(): void
    {
        sessionStorage.removeItem("accessToken");
        this._router.navigate(['/sign-in']);
    }


    showCart(){
       const token = this._authService.accessToken;
        if(token){
            return true
        }else{
            return false;
        }
    }

    focusOnSearch(): void 
    {
        if (this.searchInputRef) {
            this.searchInputRef?.nativeElement.focus();
        }
    }

    /**
     * Open Speed Test Dialog
     */
    openSpeedTest(): void {
        this.dialog.open(SpeedTestComponent, {
            width: '95vw',
            maxWidth: '900px',
            height: 'auto',
            maxHeight: '90vh',
            backdropClass: 'blurModalBackground',
            panelClass: 'speed-test-dialog-panel',
            disableClose: false
        });
    }

    // private async hashCustomerDetails() {
    //     console.log(this._authService);
    //         if ((!sessionStorage.getItem('emailHash') || !sessionStorage.getItem('phoneHash')) && this._authService._authenticated) {
    //             await this._sharedMethods.getCustomerAccount().then((res) => {
    //                 if (res.success) {
    //                     const user = res.result;
        
    //                     console.log(user);
    //                     sessionStorage.setItem('emailHash', sha256(user?.PrimaryContactEmail));
    //                     sessionStorage.setItem('phoneHash', sha256(user?.MobileUsername));
    //                 }
    //             });
    //         } else {
    //             console.log('nah');
    //             return
    //         }
        
    // }

    // Notification methods
    public onNotificationClick(notification: any): void {
        if (notification.notificationType === 'Pending_Debit_Order_Mandate') {
            this.viewLatestDebitOrder();
        }
        if (notification.notificationType === 'Account_in_Arrears') {
            this.router.navigate(['/balances']);
        }
    }

    public async viewLatestDebitOrder() {
        const { MandatePopupComponent } = await import('app/modules/financials/debit-orders/mandate-popup/mandate-popup.component');

        this.dialog.open(MandatePopupComponent, {
            disableClose: true,
            width: '80vw',
            height: 'auto',
            backdropClass: 'blurModalBackground',
            panelClass: 'fuse-confirmation-dialog-panel',
            data: {
                mandateData: this.latestPendingDO
            }
        }).afterClosed().subscribe(() => {
            location.reload(); // ! GENERALLY NOT A GOOD IDEA TO RELOAD THE WINDOW LIKE THIS, (Re-render/refresh the state instead)
        })
    }

    private async getPendingDebitOrder() {
        // debugger
        const latestPendingDO: any = await this._sharedMethods.getLatestPendingDO();
        if (latestPendingDO.success) {
            this.latestPendingDO = latestPendingDO.result;
            this.createNotification('Pending Debit Order Mandate', 'Pending_Debit_Order_Mandate', this.latestPendingDO);
        }
    }

    private createNotification(name: string, type: string, item: any) {
        // Check if notification already exists to prevent duplicates
        const existingNotification = this.notifications.find(n => n.notificationType === type);
        if (existingNotification) {
            return; // Don't add duplicate
        }

        const notification = {
            notificationType: type,
            notificationName: name,
            notificationItem: item
        }
        this.notifications.push(notification);
    }
}
